import styled from "@emotion/styled";
import { MenuSeparator } from "../../../menu";
const shouldForwardProp = propName => {
  switch (propName) {
    case "optionHeight":
    case "shouldVirtualize":
    case "top":
      // Just add any extra props here :)
      return false;
  }
  return true;
};
export const VirtualizedSeparatorStyled = styled(MenuSeparator, {
  shouldForwardProp
})`
    ${_ref => {
  let {
    shouldVirtualize,
    optionHeight,
    top
  } = _ref;
  return shouldVirtualize ? `
                ${top ? `top: ${+top - optionHeight}px` : ``};
                transform: translate(0, ${optionHeight}px);
                position: absolute;
                width: calc(100% - 32px);
              ` : ``;
}}
`;
//# sourceMappingURL=VirtualizedSeparatorStyled.js.map